<template>

  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
    scrollable
  >

     
    <v-card class="pa-5">
         <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-progress-circular
          v-if="loadingData"
          size="72"
          indeterminate
          class="text-center justify-center ma-8 d-block mx-auto"
        />
        <v-form ref="form" v-model="valid" @submit.prevent>
          <div class="permissions colored-options">
            <v-checkbox
              v-model="statisticsPermissions"
              color="accent"
              class="pa-0"
              :label="$t('checkboxStatisticsPermissions')"
              :messages="$t('checkboxStatisticsPermissionsText')"
            ></v-checkbox>
            <v-checkbox
              v-model="sharingPermissions"
              color="accent"
              class="pa-0"
              :label="$t('checkboxSharingPermissions')"
              :messages="$t('checkboxSharingPermissionsText')"
            ></v-checkbox>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show = false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="setPermissions()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import { setPermissions } from "../api/activityApi";
import AlertMessages from "../components/AlertMessages";
export default {
  components: {
    AlertMessages
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t("submit"),
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    statPermission: {
      type: Array,
      default: () => [],
    },
    sharPermission: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      statisticsPermissions: this.statPermission.find(
        (item) => item === "Analytics Activities"
      )
        ? true
        : false,
      sharingPermissions: this.sharPermission.find(
        (item) => item === "Share Activities"
      )
        ? true
        : false,
      alertValue: false,
      loadingData: false,
      activityId: this.$route.params.id,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {},
  methods: {
    proceedSubmit() {
      this.$router.push({ path: "/space/subscription" });
    },
    submitDialogBtn() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.$emit(
          "proceedSubmit",
          this.sharingPermissions,
          this.statisticsPermissions
        );
      }
    },
    async setPermissions() {
      try {
        let data = {
          data: {
            type: "activities",
            attributes: {
              user_email: this.user.email,
              enable_activity_stats: this.statisticsPermissions,
              enable_activity_sharing: this.sharingPermissions,
            },
          },
        };

        const response = await setPermissions(this.activityId, data);
        if (response.status == 200) {
          this.$emit(
            "proceedSubmit",
            this.sharingPermissions,
            this.statisticsPermissions
          );
        }
      } catch (e) {
        this.alertValue = true;
        this.alertType = "error";
        this.alertMsg = i18n.t("serverError");
      }
    },
  },
};
</script>
<style>
.colored-options.permissions .v-input--checkbox .v-messages {
  margin-left: 52px;
  color: var(--v-greytext-base) !important;
  bottom: 25px;
}
.colored-options.permissions .v-input--checkbox .v-input__slot {
  padding: 24px;
  z-index: 5;
}
</style>